import { useAnalytics } from 'src/lib/contexts/AnalyticsContext'
import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'

export const useWidgetConfig = (widgetSection: WidgetSections, widgetId: WidgetId) => {
  const {
    getters: { widgetConfig }
  } = useAnalytics()

  if (!widgetConfig[widgetSection]) {
    return {
      widget_title: 'Untitled',
      impact_config: false,
      tool_tip: {
        primary_text: 'No description',
        secondary_text: ''
      },
      l2_present: false,
      l2_config: {
        primary: ''
      },
      threshold_alerts_supported: false
    }
  }

  if (!widgetConfig[widgetSection][widgetId]) {
    return {
      widget_title: 'Untitled',
      impact_config: false,
      tool_tip: {
        primary_text: 'No description',
        secondary_text: ''
      },
      l2_present: false,
      l2_config: {
        primary: ''
      },
      threshold_alerts_supported: false
    }
  }
  return widgetConfig[widgetSection][widgetId]
}
